import $ from "jquery";

$(() => {
  if (document.querySelector('.contact-block')) {
    if (document.querySelector('.wpcf7')) {
      $("textarea").attr('rows', 6);

      let agentArray = [];
      
      let agentDiv = $("#agent-array").children("div");

      let initial = {
        name: $("#agent-list")[0].value,
        email: $("#agent-email")[0].value,
      }
      agentArray.push(initial);

      agentDiv.each((i, div) => {
        let name = $(div).children("#agent-name").text();
        let email = $(div).children("#agent-email").text();
        let agent = {
          name: name,
          email: email,
        };
        agentArray.push(agent);
      });

      $("#agent-list").on('change', function() {
        let name = this.value;
        let email = agentArray[0].email;
        for(let i = 0; i < agentArray.length; i++) {
          if( name === agentArray[i].name ){
            email = agentArray[i].email;
          };
        }
        $("#agent-email").attr("value", email);
        $("#agent-email").text(email);
      });

      const resetButton = $('.contact-block').children('.reset');
      resetButton.detach().insertAfter('.wpcf7-response-output');

      $(resetButton).on('click', function() {
        $('.wpcf7-form').trigger('reset');
      });
    }
  }
});